<template>
	<Bar :data="chartData" :range="range" :options="options" :unit="unit" ref="bar" />
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, annotationPlugin)

export default {
	components: { Bar },
	props: {
		chartData: {
			type: Object,
			required: true
		},
		range: {
			type: [Object, null],
			default: null
		},
		unit: {
			type: String,
			default: ''
		}
	},

	computed: {
		options() {
			this.chartData.labels.unshift('')
			this.chartData.labels.push('')
			this.chartData.datasets[0].data.unshift(null)
			this.chartData.datasets[0].data.push(null)
			this.chartData.datasets[0].backgroundColor.unshift(null)
			this.chartData.datasets[0].backgroundColor.push(null)
			const self = this
			const filteredData = this.chartData.datasets[0].data.filter((value) => typeof value === 'number' && !isNaN(value))
			const highestValue = Math.max(...filteredData)

			return {
				onHover: (event, chartElement) => {
					event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
					if (chartElement[0]) {
						for (let i = 0; i < this.$refs.bar.chart.data.labels.length; i++) {
							if (i === chartElement[0].index) {
								this.$refs.bar.chart.config.options.scales.x.ticks.color[i] = '#213353'
							} else {
								this.$refs.bar.chart.config.options.scales.x.ticks.color[i] = '#6E7D8D'
							}
							this.$refs.bar.chart.config.options.scales.x.ticks.color.push('red')
						}
						this.$refs.bar.chart.update()
					}
				},

				barThickness: 20,
				hoverBackgroundColor: '#213353',
				scales: {
					x: {
						grid: {
							display: false
						},
						ticks: {
							padding: 10,
							color: ['#6E7D8D'],
							font: {
								weight: 'bold'
							}
						}
					},
					y: {
						min: 0,
						max: highestValue < parseInt(this.range.high) ? parseInt(this.range.high) : highestValue,
						ticks: {
							mirror: true,
							padding: -2.5,
							labelOffset: -8,
							callback: (label) => `${typeof label === 'number' ? label.toFixed(2) : label}`,
							color: '#6E7D8D',
							font: {
								weight: 'bold'
							}
						},
						border: {
							display: false,
							dash: [3, 5]
						}
					}
				},

				plugins: {
					legend: {
						display: false
					},
					title: {
						display: true,
						text: this.unit ? this.unit : 'Neznáma jednotka',
						align: 'start',
						color: '#6E7D8D',
						font: {
							weight: 'bold',
							size: 12
						},
						padding: {
							bottom: 35
						}
					},
					tooltip: {
						enabled: true,
						backgroundColor: '#FFFFFF',
						bodyColor: '#213353',
						xAlign: 'center',
						yAlign: 'bottom',
						displayColors: false,
						bodyFont: {
							size: 14,
							weight: '400'
						},

						callbacks: {
							label: function (context) {
								return context.parsed.y + ' ' + self.unit
							},
							title: function () {
								return ''
							}
						},
						external: function (context) {
							context.chart.ctx.shadowColor = 'rgba(0, 0, 0, 0.2)'
							context.chart.ctx.shadowBlur = 20
							context.chart.ctx.shadowOffsetY = 4
						}
					},

					annotation: {
						annotations: {
							lineLow: this.range.low
								? {
										yMin: this.range.low,
										yMax: this.range.low,
										borderColor: '#F01010',
										borderDash: [3, 5]
								  }
								: null,
							lineHigh: this.range.high
								? {
										yMin: this.range.high,
										yMax: this.range.high,
										borderColor: '#F01010',
										borderDash: [3, 5]
								  }
								: null
						}
					}
				}
			}
		}
	}
}
</script>
